import { Box, type SxProps, type Theme } from '@mui/material'

interface LogoProps {
  /** Height in pixels (width scales proportionally) */
  size?: number
  sx?: SxProps<Theme>
}

export function Logo({ size = 32, sx }: LogoProps) {
  return (
    <Box
      component="img"
      src="/logo.svg"
      alt="ConnectLoop logo"
      sx={{
        height: size,
        width: 'auto',
        display: 'block',
        ...sx as Record<string, unknown>,
      }}
    />
  )
}
